(function () {

    angular
        .module('ngmvac')
        .controller('CarouselTopHotel', CarouselTopHotel);

    CarouselTopHotel.$inject = ['$window', 'HotelFactory', 'DatosCotizador', 'DestinyFactory', 'ContentApiService', '$scope', '$location'];

    function CarouselTopHotel($window, HotelFactory, DatosCotizador, DestinyFactory, ContentApiService, $scope, $location) {

        var vm = this;
        vm.destinos = [];
        vm.nationalDestinations = [];
        vm.internationalDestinations = [];
        vm.hotels = [];
        vm.loaded = false;
        vm.loaded_ = false;
        vm.itemsPerSlide = 4;
        var path = $window.location.pathname;
        var fields = path.split('/');
        vm.destination = fields[3];
        vm.country = fields[2];
        vm.press = fnPress;
        var code = $('#code').val();
        var name = $('#name').val();
        var token = $('#token').val();
        vm.hotels = [];
        vm.initializationData = {};
        vm.showHotelsInDestination = false;
        vm.initialStay = {
            checkIn: moment().add(4, 'days').format('YYYY-MM-DD'),
            checkOut: moment().add(7, 'days').format('YYYY-MM-DD')
        };
        var type = 'outlet';

        $('.footer').removeClass('hidden-xs');

        if ($(window).width() < 480) {
            vm.itemsPerSlide = 1;
        }
        //console.log($location.absUrl(), "URL");
        //console.log(/mexicovacations/i.test($location.absUrl()), "LOCATION");


        if(/mexicovacations/i.test($location.absUrl())){
            vm.itemsPerSlide = 3;
            type = 'mvac';
        }

        HotelFactory
            .getTopDestinos(type)
            .then(function (response) {
                if(angular.isDefined(response.data.international) && angular.isDefined(response.data.national)){
                    console.log('datos-impresos',response);
                    // National
                    var nationalDestinations = response.data.national;
                    var lengthNational = nationalDestinations.length;
                    var indexNational = 0;
                    var countNational = 0;
                    while (countNational < lengthNational) {
                        vm.nationalDestinations[indexNational] = [];
                        for (var i = 0; i < vm.itemsPerSlide; i++) {
                            if (countNational < lengthNational) {
                                if (nationalDestinations[countNational].available) {
                                    //console.log(nationalDestinations[countNational], "destinos");
                                    nationalDestinations[countNational].url ="load?rt=hotel&source=MVAC&checkIn=" + nationalDestinations[countNational].cotizador.stay.checkIn + "&checkOut=" + nationalDestinations[countNational].cotizador.stay.checkOut + "&code=" + nationalDestinations[countNational].cotizador.destination.destinationCode + "&language=CAS&adults_1=2&children_1=0&type=Destiny"
                                    vm.nationalDestinations[indexNational].push(nationalDestinations[countNational]);
                                }
                            }
                            countNational++;
                        }
                        indexNational++;
                    }

                    var internationalDestinations = response.data.international;
                    var lengthInternational = internationalDestinations.length;
                    var indexInternational = 0;
                    var countInternational = 0;
                    while (countInternational < lengthInternational) {
                        vm.internationalDestinations[indexInternational] = [];
                        for (var i = 0; i < vm.itemsPerSlide; i++) {
                            if (countInternational < lengthInternational) {
                                if (internationalDestinations[countInternational].available) {
                                    vm.internationalDestinations[indexInternational].push(internationalDestinations[countInternational]);
                                }
                            }
                            countInternational++;
                        }
                        indexInternational++;
                    }


                }else{
                    var destinos = response.data;
                    var length = destinos.length;
                    var count = 0;
                    var index = 0;
                    while (count < length) {
                        vm.destinos[index] = [];
                        for (var i = 0; i < vm.itemsPerSlide; i++) {
                            if (count < length) {
                                if (destinos[count].available) {
                                    vm.destinos[index].push(destinos[count]);
                                }
                            }
                            count++;
                        }
                        index++;
                    }
                }
                vm.loaded = true;
            })
            .catch(function (err) {

            });

        if (path != '/') {
            setTimeout(function () {
                vm.initializationData = {
                    destination: {
                        destinationCode: code,
                        name: name,
                        tipo: 'destino'
                    },
                    stay: vm.initialStay,
                    token: token,
                    type: 'Destiny'
                };
                $scope.$apply();
            }, 1500);

            DestinyFactory
                .getHotelsFromDB()
                .then(function (response) {
                    switch (response.status) {
                        case 204:
                            vm.showHotelsInDestination = false;
                            break;
                        default:
                            var count_ = 0;
                            var index_ = 0;
                            var length = response.data.hotels.length;
                            var params = {
                                destiny: vm.destination,
                                checkIn: moment().add(4, 'days').format('YYYY-MM-DD'),
                                checkOut: moment().add(7, 'days').format('YYYY-MM-DD'),
                                codes: response.data.codes
                            }
                            DestinyFactory
                                .get_(params)
                                .then(function (response_) {
                                    vm.loaded_ = true;
                                    switch (response_.status) {
                                        case 204:
                                            break;
                                        default:
                                            angular.forEach(response.data.hotels, function (hotel) {
                                                hotel.rates = false;
                                                angular.forEach(response_.data.hotels, function (hotel_) {
                                                    if (hotel.code == hotel_.code) {
                                                        hotel.rates = true;
                                                        hotel.availability = hotel_;
                                                    }
                                                });
                                            });
                                    }
                                });
                            angular.forEach(response.data.hotels, function (hotel) {
                                hotel.content = {};
                                hotel.content.images = [{
                                    path: hotel.image,
                                    imageTypeCode: 'GEN'
                                }];
                            });
                            while (count_ < length) {
                                vm.hotels[index_] = [];
                                for (var i = 0; i < vm.itemsPerSlide; i++) {
                                    if (count_ < length) vm.hotels[index_].push(response.data.hotels[count_]);
                                    count_++;
                                }
                                index_++;
                            }
                            vm.showHotelsInDestination = true;
                            break;
                    }
                }).catch(function (err) {

                });;
        }

        vm.loadDestiny = function (destino) {
            DatosCotizador.destination = destino.cotizador.destination;
            DatosCotizador.stay = destino.cotizador.stay;
            DatosCotizador.occupancies = [];

            angular.forEach(destino.cotizador.occupancies, function (occupancy) {
                DatosCotizador.occupancies.push({
                    adults: parseInt(occupancy.adults),
                    children: parseInt(occupancy.children),
                    paxes: occupancy.paxes,
                    rooms: parseInt(occupancy.rooms)
                });
            });

            DatosCotizador.step = destino.cotizador.step;
            DatosCotizador.type = destino.cotizador.type;
            DatosCotizador.token = destino.cotizador.token;

            HotelFactory
                .obtenerHoteles()
                .then(function (response) {
                    if (response.status == 200) {
                        location.href = '/' + destino.cotizador.destination.url + '/lista/hoteles';
                    }
                })
                .catch(function (err) {

                });
        }

        vm.loadDetails = function (hotel) {
            location.href = '/hotel/details/' + hotel.tokenName + '?flt=AI';
        }

        function fnPress($event) {
            if ($event.isValid) {
                vm.loaderStyle = {
                    display: 'block'
                };
                HotelFactory
                    .obtenerHoteles()
                    .then(function (response) {
                        switch (response.status) {
                            case 204:
                                break;
                            case 200:
                                if (DatosCotizador.type === 'Hotel') {
                                    $window.location.href = '/hotel/details/' + DatosCotizador.destination.token + '?flt=AI';
                                } else {
                                    $window.location.href = '/hotelv2';
                                }
                                break;
                        }
                    })
                    .catch(function (err) {
                        vm.loaderStyle = {
                            display: 'none'
                        };
                        switch (err.status) {
                            case 422:
                                var message = '';
                                for (var field in err.data) {
                                    angular.forEach(err.data[field], function (error) {
                                        message += '<div>' + error + '</div>';
                                    });
                                }
                                alertMsg(message);
                                break;
                            default:
                                alertMsg('No hemos podido procesar su petición. Intente de nuevo.');
                                break;
                        }
                    });
            }
        }
    }

})();